import React, { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import ScrollToTop from '../../functions/ScrollToTop'
import Navbar from '../Navbar'
import useMediaQuery from '../../hooks/useMediaQuery'
import '../../css/AdminLayout.css'

const PAGE_LANGUAGE_ROUTES = [
  "/customers",
  "/merchants",
  "/registration-reviews",
  "/installment-operations"
];

const USER_MANAGEMENT_ROUTES = [
  "/customers",
  "/merchants",
  "/registration-reviews",
  "/installment-operations"
];

const Layout = () => {
  const location = useLocation();
  const [pageLanguage, setPageLanguage] = useState("en");
  const [sidebarExpanded, setSidebarExpanded] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width: 575px)");
  const supportsPageLanguage = PAGE_LANGUAGE_ROUTES.includes(location.pathname);
  const isUserManagementRoute = USER_MANAGEMENT_ROUTES.includes(location.pathname);
  const activeLanguage = supportsPageLanguage ? pageLanguage : "en";
  const activeDirection = activeLanguage === "ar" ? "rtl" : "ltr";

  useEffect(() => {
    if (!supportsPageLanguage) {
      setPageLanguage("en");
    }
  }, [supportsPageLanguage]);

  useEffect(() => {
    if (!isMobile) setMobileMenuOpen(false);
  }, [isMobile]);

  const togglePageLanguage = () => {
    setPageLanguage((currentLanguage) =>
      currentLanguage === "en" ? "ar" : "en"
    );
  };

  return <>
      <ScrollToTop/>
      <Navbar
        showLanguageToggle={supportsPageLanguage}
        language={activeLanguage}
        onToggleLanguage={togglePageLanguage}
        expanded={sidebarExpanded}
        onToggleExpanded={() => setSidebarExpanded((value) => !value)}
        isMobile={isMobile}
        mobileMenuOpen={mobileMenuOpen}
        onOpenMobileMenu={() => setMobileMenuOpen(true)}
        onCloseMobileMenu={() => setMobileMenuOpen(false)}
      />
      <div
        className={`admin-layout-content${isUserManagementRoute ? " is-user-management-route" : ""}`}
        data-sidebar-state={sidebarExpanded ? "expanded" : "collapsed"}
        data-mobile-layout={isMobile}
        data-testid="admin-layout-content"
        dir={activeDirection}
      >
      <Outlet context={{ language: activeLanguage, direction: activeDirection }}></Outlet>

      </div>
  </>
}

export default Layout
